(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("iEIlo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $21069d89161492ba$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $l8eky = parcelRequire("l8eky");

var $cUbQm = parcelRequire("cUbQm");

var $9CeA9 = parcelRequire("9CeA9");

var $exvWl = parcelRequire("exvWl");

var $24dNh = parcelRequire("24dNh");

var $67EyS = parcelRequire("67EyS");

var $8IDY3 = parcelRequire("8IDY3");

const $21069d89161492ba$var$MobileSearchTags = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("3ukJK")));

const $21069d89161492ba$var$DesktopSearchTags = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("8pK8e")));

const $21069d89161492ba$var$AcReultsMuni = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("95PRH")));

const $21069d89161492ba$var$AcReultsArea = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("ji2OJ")));

const $21069d89161492ba$var$AcReultsCounty = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("9BjyT")));

const $21069d89161492ba$var$AcResultsEstates = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("crrJ0")));
const $21069d89161492ba$var$basename = "/till-salu/";
const $21069d89161492ba$var$estateTypes = Object.entries((0, $cUbQm.EstateType)).filter((estateType)=>estateType[1] !== (0, $cUbQm.EstateType).OwnedApartment && estateType[1] !== (0, $cUbQm.EstateType).Premises).map(([_, value])=>value);
const $21069d89161492ba$var$roomsMinNumber = [
    "2",
    "3",
    "4",
    "5",
    "6"
];
const $21069d89161492ba$var$SearchForm = ({ shouldShowSearchResults: shouldShowSearchResults, shouldShowNoSearchResults: shouldShowNoSearchResults })=>{
    const { register: register, handleSubmit: handleSubmit, watch: watch, setValue: setValue } = (0, $exvWl.useForm)({});
    const ref = (0, $dTCkE.useRef)(null);
    (0, $l8eky.useOnClickOutside)(ref, ()=>setHideAc(true));
    const [showSearchResults, setShowSearchResults] = (0, $dTCkE.useState)(false);
    const [showNoSearchResults, setShowNoSearchResults] = (0, $dTCkE.useState)(false);
    const [hideAC, setHideAc] = (0, $dTCkE.useState)(false);
    const [acResults, setACResults] = (0, $dTCkE.useState)();
    let searchTerm = watch("searchTerm", "");
    const debouncedSearchTerm = (0, $l8eky.useDebounce)(searchTerm, 200);
    const [freetext, setFreetext] = (0, $dTCkE.useState)("");
    const { data: resp } = (0, $8IDY3.default)(freetext);
    const isMediumScreen = (0, $67EyS.default)("(min-width: 64rem)");
    const mergedPrettyNamesContainer = (0, $dTCkE.useRef)(null);
    const methods = (0, $exvWl.useForm)({
        defaultValues: {
            searchTerm: "",
            municipality: [],
            area: [],
            county: [],
            estateType: "",
            roomsMin: "",
            roomsMax: "10"
        }
    });
    const [mergedPrettyNames, setMergedPrettyNames] = (0, $dTCkE.useState)([]);
    (0, $dTCkE.useEffect)(()=>{
        const subscription = methods.watch((value)=>{
            const municipalities = value.municipality.map((item)=>({
                    prettyName: item.prettyName,
                    type: item.type
                }));
            const areas = value.area.map((item)=>({
                    prettyName: item.prettyName,
                    type: item.type
                }));
            const counties = value.county.map((item)=>({
                    prettyName: item.prettyName,
                    type: item.type
                }));
            const merged = [
                ...municipalities,
                ...areas,
                ...counties
            ];
            setMergedPrettyNames(merged);
        });
        return ()=>subscription.unsubscribe();
    }, [
        methods
    ]);
    (0, $dTCkE.useEffect)(()=>{
        setACResults(resp);
    }, [
        resp
    ]);
    (0, $dTCkE.useEffect)(()=>{
        const query = debouncedSearchTerm.trim();
        if (!query || query.length < 2) setACResults(null);
        else {
            setFreetext(query);
            setHideAc(false);
        }
    }, [
        debouncedSearchTerm
    ]);
    (0, $dTCkE.useEffect)(()=>{
        setShowSearchResults(shouldShowSearchResults(hideAC, acResults));
        setShowNoSearchResults(shouldShowNoSearchResults(hideAC, acResults));
    }, [
        hideAC,
        acResults
    ]);
    const onSubmit = ()=>{
        const { municipality: municipality, area: area, county: county, estateType: estateType, roomsMin: roomsMin, roomsMax: roomsMax } = methods.getValues();
        let queryString = "?";
        if (municipality.length > 0) queryString += `municipality=${encodeURIComponent(municipality.map((item)=>item.name).join(","))}&`;
        if (area.length > 0) queryString += `areaIds=${encodeURIComponent(area.map((item)=>item.areaId).join(","))}&`;
        if (area.length > 0) queryString += `areaNames=${encodeURIComponent(area.map((item)=>item.name).join(","))}&`;
        if (county.length > 0) queryString += `county=${encodeURIComponent(county.map((item)=>item.name).join(","))}&`;
        if (estateType) queryString += `estateType=${encodeURIComponent(estateType)}&`;
        if (roomsMin) {
            queryString += `roomsMin=${encodeURIComponent(roomsMin)}&`;
            queryString += `roomsMax=${encodeURIComponent(roomsMax)}&`;
        }
        if (queryString.endsWith("&") || queryString.endsWith("?")) queryString = queryString.slice(0, -1);
        window.location.href = $21069d89161492ba$var$basename + queryString;
    };
    const handlePick = (name, typeName, type, id, areaMuni)=>{
        setValue("searchTerm", "");
        setShowSearchResults(false);
        setHideAc(true);
        if (type === "municipality") {
            const currentMunicipalities = methods.getValues("municipality");
            if (!currentMunicipalities.some((item)=>item.name === name)) {
                const updatedMunicipalities = [
                    ...currentMunicipalities,
                    {
                        name: name,
                        prettyName: `${name} (${typeName})`,
                        type: type
                    }
                ];
                methods.setValue("municipality", updatedMunicipalities);
            }
        } else if (type === "area") {
            const currentAreas = methods.getValues("area");
            if (!currentAreas.some((area)=>area.areaId === id)) {
                const updatedAreas = [
                    ...currentAreas,
                    {
                        areaId: id,
                        name: name,
                        prettyName: `${name} (${typeName})`,
                        type: type,
                        areaMuni: areaMuni
                    }
                ];
                methods.setValue("area", updatedAreas);
            }
        } else if (type === "county") {
            const currentCounties = methods.getValues("county");
            if (!currentCounties.some((item)=>item.name === name)) {
                const updatedCounties = [
                    ...currentCounties,
                    {
                        name: name,
                        prettyName: `${name} (${typeName})`,
                        type: type
                    }
                ];
                methods.setValue("county", updatedCounties);
            }
        }
    };
    const removeFromMergedPrettyNames = (type, prettyName)=>{
        const updatedMergedPrettyNames = mergedPrettyNames.filter((item)=>item.prettyName !== prettyName);
        setMergedPrettyNames(updatedMergedPrettyNames);
        // Update defaultValues in methods based on type and prettyName
        if (type === "municipality") {
            const updatedDefaultValues = {
                ...methods.getValues(),
                municipality: methods.getValues("municipality").filter((item)=>item.prettyName !== prettyName)
            };
            methods.reset(updatedDefaultValues);
        } else if (type === "area") {
            const updatedDefaultValues = {
                ...methods.getValues(),
                area: methods.getValues("area").filter((item)=>item.prettyName !== prettyName)
            };
            methods.reset(updatedDefaultValues);
        } else if (type === "county") {
            const updatedDefaultValues = {
                ...methods.getValues(),
                county: methods.getValues("county").filter((item)=>item.prettyName !== prettyName)
            };
            methods.reset(updatedDefaultValues);
        }
    };
    (0, $dTCkE.useEffect)(()=>{
        if (mergedPrettyNamesContainer.current) mergedPrettyNamesContainer.current.scrollLeft = mergedPrettyNamesContainer.current.scrollWidth;
    }, [
        mergedPrettyNames
    ]);
    const [focusInput, setFocusInput] = (0, $dTCkE.useState)(false);
    const [overflow, setOverflow] = (0, $dTCkE.useState)("lg:overflow-visible");
    (0, $dTCkE.useEffect)(()=>{
        if (mergedPrettyNames.length > 0) {
            if (focusInput) setOverflow("lg:overflow-hidden");
            else setTimeout(()=>{
                setOverflow("lg:overflow-visible");
            }, 300);
        }
    }, [
        focusInput
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        id: "searchfield-input-wrapper",
        className: "lg:flex flex-grow lg:pt-1 pb-2 lg:pb-1",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("form", {
            className: "w-full",
            onSubmit: handleSubmit(onSubmit),
            role: "search",
            "aria-label": "Bostadss\xf6kning",
            children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: `flex flex-col lg:grid ${focusInput ? mergedPrettyNames.length > 0 ? "lg:grid-cols-[6fr_2fr_1fr]" : "lg:grid-cols-[4fr_4fr_1fr]" : "lg:grid-cols-[4fr_4fr_1fr]"} lg:bg-white lg:rounded-[60px] lg:items-center lg:py-3 lg:px-4 gap-1 transition-all w-full`,
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                className: "flex flex-row items-center gap-2 lg:gap-4 psuedo-border-after bg-white lg:shadow-none px-4 lg:pl-1 border-none rounded-full w-full outline-none",
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        src: "/Images/Icons/location-blue.svg",
                                        alt: "",
                                        "aria-hidden": "true",
                                        className: "w-5.5 h-auto"
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                        className: "lg:flex lg:flex-col w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("label", {
                                                id: "searchfield-label",
                                                className: "lg:block hidden font-icb text-blue700 text-sm",
                                                children: (0, $9CeA9.Autocomplete).LocationPick
                                            }),
                                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                                className: "flex lg:justify-start lg:gap-2",
                                                children: [
                                                    mergedPrettyNames && mergedPrettyNames.length > 0 && isMediumScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$DesktopSearchTags, {
                                                            removeFromMergedPrettyNames: removeFromMergedPrettyNames,
                                                            mergedPrettyNames: mergedPrettyNames,
                                                            mergedPrettyNamesContainer: mergedPrettyNamesContainer
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $a9eYm.jsx)("input", {
                                                        id: "searchfield-input",
                                                        autoComplete: "off",
                                                        className: "bg-white placeholder:opacity-100 px-1 lg:px-0 py-[11px] lg:py-1 rounded-3xl lg:rounded-none w-full min-w-[100px] text-base lg:text-black500 placeholder:text-grey400 outline-none searchfield-input-hero",
                                                        type: "search",
                                                        value: searchTerm ?? "",
                                                        placeholder: (0, $cUbQm.Estates).SearchPlaceholder,
                                                        "aria-labelledby": "searchfield-label",
                                                        "aria-autocomplete": "list",
                                                        "aria-expanded": showSearchResults,
                                                        "aria-controls": showSearchResults ? "ac-result-list" : undefined,
                                                        onClick: ()=>setHideAc(false),
                                                        ...(register("searchTerm"), {
                                                            onFocus: ()=>setFocusInput(true),
                                                            onBlur: ()=>setFocusInput(false),
                                                            onChange: (e)=>setValue("searchTerm", e.target.value)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            mergedPrettyNames && mergedPrettyNames.length > 0 && !isMediumScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$MobileSearchTags, {
                                    removeFromMergedPrettyNames: removeFromMergedPrettyNames,
                                    mergedPrettyNames: mergedPrettyNames
                                })
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                ref: ref,
                                children: [
                                    showSearchResults && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                        id: "ac-result-list",
                                        className: "top-12 lg:top-[66px] left-0 z-50 absolute bg-grey50 shadow-bs80 rounded-2xl w-full max-h-sm overflow-hidden overflow-y-auto",
                                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $dTCkE.Suspense), {
                                            fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                            children: [
                                                !!acResults?.municipalities.length && /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$AcReultsMuni, {
                                                    acResults: acResults,
                                                    handlePick: handlePick
                                                }),
                                                !!acResults?.areas.length && /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$AcReultsArea, {
                                                    acResults: acResults,
                                                    handlePick: handlePick
                                                }),
                                                !!acResults?.counties.length && /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$AcReultsCounty, {
                                                    acResults: acResults,
                                                    handlePick: handlePick
                                                }),
                                                !!acResults?.estates.length && /*#__PURE__*/ (0, $a9eYm.jsx)($21069d89161492ba$var$AcResultsEstates, {
                                                    acResults: acResults.estates
                                                })
                                            ]
                                        })
                                    }),
                                    showNoSearchResults && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                            className: "top-[1px] lg:top-[14px] left-1/2 z-50 absolute bg-grey50 shadow-bs80 p-3 rounded-2xl w-[95vw] lg:w-full max-h-xl -translate-x-1/2 overflow-hidden overflow-y-auto",
                                            children: [
                                                "Din s\xf6kning p\xe5",
                                                " ",
                                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                    className: "font-icb",
                                                    children: searchTerm
                                                }),
                                                " gav inga resultat."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: `flex flex-col gap-1 lg:gap-0 lg:grid transition-all ${overflow} ${focusInput ? mergedPrettyNames.length > 0 ? "lg:grid-cols-[220px_220px]" : "lg:grid-cols-2" : "lg:grid-cols-2"}`,
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $24dNh.default), {
                                name: "estateType",
                                options: $21069d89161492ba$var$estateTypes,
                                setValue: methods.setValue,
                                getValues: methods.getValues,
                                labelText: (0, $9CeA9.Autocomplete).EstateTypeLabel,
                                placeholderText: (0, $9CeA9.Autocomplete).PickType,
                                icon: "/Images/Icons/SearchStartPage/estate-type-icon.svg"
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $24dNh.default), {
                                name: "roomsMin",
                                options: $21069d89161492ba$var$roomsMinNumber,
                                setValue: methods.setValue,
                                getValues: methods.getValues,
                                labelText: (0, $9CeA9.Autocomplete).RoomsMin,
                                placeholderText: (0, $9CeA9.Autocomplete).PickRoom,
                                icon: "/Images/Icons/SearchStartPage/room-icon.svg",
                                psuedo: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                        onClick: handleSubmit(onSubmit),
                        type: "submit",
                        className: "flex justify-center items-center border-2 bg-blue700 mt-1 lg:mt-0 lg:px-2 p-2 border-blue700 rounded-3xl w-full lg:w-28 font-icb text-white dark:text-white hover-darken-blue",
                        children: [
                            (0, $9CeA9.Autocomplete).Search,
                            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                width: "16",
                                height: "16",
                                className: "ml-3 w-4",
                                src: "/Images/Icons/search-icon.svg",
                                alt: "",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $21069d89161492ba$export$2e2bcd8739ae039 = $21069d89161492ba$var$SearchForm;

});
parcelRegister("9CeA9", function(module, exports) {

$parcel$export(module.exports, "Autocomplete", function () { return $95e87e4cb651c7eb$export$2f2b9559550c7bbc; });
var $95e87e4cb651c7eb$export$2f2b9559550c7bbc;
(function(Autocomplete) {
    Autocomplete["Search"] = "S\xf6k";
    Autocomplete["RoomsMin"] = "Minst antal rum";
    Autocomplete["PickRoom"] = "V\xe4lj antal rum";
    Autocomplete["EstateTypeLabel"] = "Hur vill du bo?";
    Autocomplete["PickType"] = "V\xe4lj bostadstyp";
    Autocomplete["LocationPick"] = "Var vill du bo?";
})($95e87e4cb651c7eb$export$2f2b9559550c7bbc || ($95e87e4cb651c7eb$export$2f2b9559550c7bbc = {}));

});

parcelRegister("24dNh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fa3e06333fa62e9$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $67EyS = parcelRequire("67EyS");
const $0fa3e06333fa62e9$var$DropDown = ({ name: name, options: options, setValue: setValue, getValues: getValues, labelText: labelText, placeholderText: placeholderText, icon: icon, psuedo: psuedo })=>{
    const [open, setOpen] = (0, $dTCkE.useState)(false);
    const dropDownRef = (0, $dTCkE.useRef)(null);
    const isMediumScreen = (0, $67EyS.default)("(min-width: 64rem)");
    const [activeIndex, setActiveIndex] = (0, $dTCkE.useState)(-1);
    const selectOption = (option)=>{
        setOpen(false);
        setValue(name, option);
    };
    const handleClickOutside = (event)=>{
        if (dropDownRef.current && !dropDownRef.current.contains(event.target)) setOpen(false);
    };
    (0, $dTCkE.useEffect)(()=>{
        if (open) document.addEventListener("mousedown", handleClickOutside);
        else document.removeEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        open
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen((prev)=>!prev);
        } else if (e.key === "ArrowDown" && open) {
            e.preventDefault();
            setActiveIndex(0);
        } else if (e.key === "Escape" && open) {
            e.preventDefault();
            setOpen(false);
        }
    };
    const handleOptionKeyDown = (e, index)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            selectOption(options[index]);
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex(Math.min(index + 1, options.length - 1));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (index > 0) setActiveIndex(index - 1);
            else dropDownRef.current?.querySelector("button")?.focus();
        } else if (e.key === "Escape") {
            e.preventDefault();
            setOpen(false);
            dropDownRef.current?.querySelector("button")?.focus();
        }
    };
    (0, $dTCkE.useEffect)(()=>{
        if (activeIndex >= 0 && open) {
            const options = dropDownRef.current?.querySelectorAll('[role="option"]');
            if (options?.[activeIndex]) options[activeIndex].focus();
        }
    }, [
        activeIndex,
        open
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        ref: dropDownRef,
        className: `relative ${psuedo ? "lg:before:content-[''] lg:before:w-[1px] lg:before:h-5/6 lg:before:bg-grey100 lg:before:absolute lg:before:-left-[18px] lg:before:top-1/2 lg:before:-translate-y-1/2" : ""}`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex flex-row items-center gap-2 lg:gap-4 bg-white lg:shadow-none px-4 lg:px-2 border border-none rounded-3xl w-full",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                        className: "w-5.5 h-auto",
                        src: icon,
                        alt: "",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "w-full lg:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("label", {
                                id: `${name}-label`,
                                className: "lg:block hidden font-icb text-blue700 text-sm whitespace-nowrap",
                                children: labelText
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                                id: name,
                                "aria-labelledby": `${name}-label`,
                                "aria-haspopup": "listbox",
                                "aria-expanded": open,
                                "aria-controls": open ? `${name}-listbox` : undefined,
                                className: "flex justify-between lg:justify-normal items-center lg:gap-4 w-full text-left cursor-pointer",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setOpen((prevValue)=>!prevValue);
                                },
                                onKeyDown: handleKeyDown,
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                        className: "px-1 lg:px-0 py-[11px] lg:py-1 w-full lg:w-fit font-ic text-base lg:text-black500 whitespace-nowrap",
                                        children: getValues(name) ? getValues(name) : /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                            className: "font-ic text-grey400 whitespace-nowrap",
                                            children: isMediumScreen ? placeholderText : labelText
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        className: `w-[10px] h-auto transition-all duration-75 ${open ? "rotate-180" : ""}`,
                                        src: "/Images/Icons/Arrows/arrow-down-simple-black500.svg",
                                        alt: "",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                id: `${name}-listbox`,
                role: "listbox",
                "aria-labelledby": `${name}-label`,
                className: "top-12 lg:top-[66px] left-1/2 z-10 absolute flex flex-col bg-grey50 shadow-bs80 rounded-2xl w-[92%] lg:w-fit lg:min-w-[180px] max-h-s -translate-x-1/2 overflow-x-hidden overflow-y-auto",
                children: options.map((option, index)=>/*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                        role: "option",
                        "aria-selected": getValues(name) === option,
                        tabIndex: activeIndex === index ? 0 : -1,
                        className: "flex justify-between border-grey100 hover:bg-blue100 px-4 py-2 border-b w-full font-ic cursor-pointer outline-none focus-visible:bg-blue100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue400 focus-visible:-outline-offset-2",
                        onClick: ()=>selectOption(option),
                        onKeyDown: (e)=>handleOptionKeyDown(e, index),
                        children: option
                    }, option))
            })
        ]
    });
};
var $0fa3e06333fa62e9$export$2e2bcd8739ae039 = $0fa3e06333fa62e9$var$DropDown;

});
parcelRegister("67EyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23722fec40a37891$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $23722fec40a37891$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $dTCkE.useState)();
    (0, $dTCkE.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>setMatches(media.matches);
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        query,
        matches
    ]);
    return matches;
};
var $23722fec40a37891$export$2e2bcd8739ae039 = $23722fec40a37891$var$useMediaQuery;

});


parcelRegister("8IDY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39fd1f118f25a738$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $39fd1f118f25a738$var$useAutocomplete = (freetext)=>{
    return (0, $4cyLg.useQuery)([
        "freetext",
        freetext
    ], ()=>(0, $1HGFx.SearchService).searchAutoComplete(freetext).then((response)=>response), {
        enabled: !!freetext,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $39fd1f118f25a738$export$2e2bcd8739ae039 = $39fd1f118f25a738$var$useAutocomplete;

});

parcelRegister("3ukJK", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("dXXUh")).then(()=>parcelRequire("3PfsJ"));

});

parcelRegister("8pK8e", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hKkvz")).then(()=>parcelRequire("4Zm4e"));

});

parcelRegister("95PRH", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("gkoKq")).then(()=>parcelRequire("5yqz6"));

});

parcelRegister("ji2OJ", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iFOcF")).then(()=>parcelRequire("i7pfc"));

});

parcelRegister("9BjyT", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("1FwtT")).then(()=>parcelRequire("kJdHa"));

});

parcelRegister("crrJ0", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("5AFa6")).then(()=>parcelRequire("8CQzn"));

});


parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

})();
//# sourceMappingURL=SearchForm.73c339c6.js.map
